import { Outlet } from "react-router-dom";
import whitelogo from "../../assets/images/white-logo.png";
import { motion } from "framer-motion";

function AuthLayout() {
  return (
    <div className="flex min-h-screen w-full">
      {/* Left Panel (Branding) */}
      <div className="hidden lg:flex items-center justify-center bg-[#002140] w-1/2 px-12 relative">
        {/* Main Centered Container */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center justify-center w-full max-w-md space-y-8 text-center text-primary-foreground"
        >
          {/* Profile Images (Top) */}
          <motion.div
            className="flex -space-x-3 relative" // Added relative positioning
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            {[
              "https://ca.slack-edge.com/T01AJ7CC7A5-U01AB4CU24A-e01858397898-192",
              "https://ca.slack-edge.com/T01AJ7CC7A5-U01A5QDUQRZ-0f03257cbb5d-192",
            ].map((src, index) => (
              <motion.img
                key={index}
                alt="Profile"
                className="w-20 h-20 rounded-full border-2 border-white transition-all duration-300 cursor-pointer relative" // Added relative
                style={{ zIndex: 1 }} // Base z-index
                src={src}
                initial={{ opacity: 0, x: 20 * (index + 1) }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{
                  scale: 1.15,
                  zIndex: 20, // Higher than other images
                  boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
                }}
              />
            ))}
          </motion.div>

          {/* Text and Logo (Centered) */}
          <motion.div
            className="space-y-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <motion.h1
              className="text-4xl text-white font-extrabold tracking-tight hover:text-blue-200 transition-colors duration-300"
              whileHover={{ scale: 1.02 }}
            >
              Welcome to Digital Innovation
            </motion.h1>
            <motion.img
              src={whitelogo}
              alt="logo"
              className="w-40 h-auto mx-auto hover:scale-105 transition-transform duration-300"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.6 }}
              whileHover={{
                scale: 1.1,
                rotate: [0, -5, 5, -5, 0],
                transition: { duration: 0.5 },
              }}
            />
          </motion.div>
        </motion.div>
      </div>

      {/* Right Panel (Form Content) */}
      <motion.div
        className="flex flex-1 items-center justify-center bg-background px-4 py-12 sm:px-6 lg:px-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        <Outlet />
      </motion.div>
    </div>
  );
}

export default AuthLayout;
